import { useHeadObject } from 'hooks/useHeadObject';
import { useMember } from 'hooks/useMember';
import { useSignUrl } from 'hooks/useSignUrl';
import { memo } from 'react';

import { DataDownload } from 'components';

function CrsCsvDownload({ chartCode }: { chartCode: string }) {
  const { member } = useMember();
  const { id, profile } = member as any;
  const parentId = profile?.mepr_parent_id;
  const key = parentId || id;
  const { data: exists } = useHeadObject(`custom-research/${chartCode}.csv`);
  const { url: csvUrl } = useSignUrl(`${key}/custom-research/${chartCode}.csv`);

  if (!exists || !csvUrl) {
    return null;
  }

  return <DataDownload url={csvUrl} filename={`${chartCode}.csv`} />;
}

CrsCsvDownload.displayName = 'CrsCsvDownload';

export default memo(CrsCsvDownload);
